module.exports = __webpack_public_path__ + "static/media/Note-Click-Enter-Textures-Click_in_00040.d6e41e65.png";